import React, { useEffect, useState } from "react";
import members from "../../assets/Data/members";
import alums from "../../assets/Data/alums";
import mentors from "../../assets/Data/mentors";
import { useParams } from "react-router-dom";
import Horizontaltimeline from "react-horizontal-timeline";
import * as Scroll from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faAngleLeft,
  faAngleRight,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faLinkedinIn,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";

export default function Team() {
  var scroller = Scroll.scroller;

  const [showText, setShowText] = useState({});
  const params = useParams();

  const [val, setVal] = useState({ value: 0, previous: 0 });

  const handleEnter = (idx) => () => {
    setShowText((state) => ({
      ...state,
      [idx]: !state[idx],
    }));
  };
  const handleExit = (idx) => () => {
    setShowText((state) => ({
      ...state,
      [idx]: !state[idx],
    }));
  };

  const beginYear = 2015;
  // Hardcode the current year to 2025 as requested
  const currentYear = 2025;

  var VALUES = [];
  for(var i = currentYear; i>=beginYear ; i--) {
    VALUES.push(`${i}-01-01`)
  }

  const [year, setYear] = useState(currentYear);

  const linePadding = 120;

  useEffect(() => {
    if (params.year) {
      setYear(parseInt(params.year));
      setVal({ value: parseInt(params.year) - beginYear, previous: beginYear });
      scroller.scrollTo("alumni", {
        duration: 1500,
      });
    } else {
      setYear(currentYear);
    }
  }, [params.year, scroller, currentYear, beginYear]);

  return (
    <div className="teampage-container">
      <div className="teampage-header-container"></div>
      <div className="team">
        <span className="">
          Meet the <b>Team</b>{" "}
        </span>
        <div className="team-table">
          {members.map((item, idx) => {
            // Use detected image extension and absolute path from public/
            let imgLink = `url("/member_images/${item.id}${item.imageExt || '.jpg'}")`;

            return (
              <div className="member" key={idx}>
                <div
                  onMouseEnter={handleEnter(idx)}
                  onMouseLeave={handleExit(idx)}
                  className="profile-image"
                  style={{
                    backgroundImage: imgLink,
                  }}
                ></div>
                <div className="member-name">
                  {showText[idx] ? item.nickname : item.name}
                </div>
                <div className="member-designation">{item.designation}</div>
                <div className="social-link">
                  <a
                    href={item.facebook}
                    target="_blank"
                    rel="noreferrer"
                    id="link"
                    className={`icon-${item.facebook ? "shown" : "hidden"}`}
                  >
                    <FontAwesomeIcon icon={faFacebookF} />
                  </a>

                  <a
                    href={item.mail}
                    target="_blank"
                    rel="noreferrer"
                    className={`icon-${item.mail ? "shown" : "hidden"}`}
                  >
                    <FontAwesomeIcon icon={faEnvelope} />
                  </a>
                  <a
                    href={item.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    className={`icon-${item.linkedin ? "shown" : "hidden"}`}
                  >
                    <FontAwesomeIcon icon={faLinkedinIn} />
                  </a>
                  <a
                    href={item.github}
                    target="_blank"
                    rel="noreferrer"
                    className={`icon-${item.github ? "shown" : "hidden"}`}
                  >
                    <FontAwesomeIcon icon={faGithub} />
                  </a>
                </div>
              </div>
            );
          })}
        </div>

        <span className="">
          Our <b>Mentors</b>{" "}
        </span>

        <div className="team-table">
          {mentors.map((item, idx) => {
            let imgLink = `url("${item.image}")`;

            return (
              <div className="member" key={idx}>
                <div
                  className="mentor-image"
                  style={{
                    backgroundImage: imgLink,
                  }}
                ></div>
                <div className="member-name">{item.name}</div>
                <div className="member-designation">{item.designation}</div>
                <div className="social-link">
                  <a
                    href={item.facebook}
                    target="_blank"
                    rel="noreferrer"
                    id="link"
                    className={`icon-${item.facebook ? "shown" : "hidden"}`}
                  >
                    <FontAwesomeIcon icon={faFacebookF} />
                  </a>

                  <a
                    href={item.mail}
                    target="_blank"
                    rel="noreferrer"
                    className={`icon-${item.mail ? "shown" : "hidden"}`}
                  >
                    <FontAwesomeIcon icon={faEnvelope} />
                  </a>
                  <a
                    href={item.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    className={`icon-${item.linkedin ? "shown" : "hidden"}`}
                  >
                    <FontAwesomeIcon icon={faLinkedinIn} />
                  </a>
                  <a
                    href={item.github}
                    target="_blank"
                    rel="noreferrer"
                    className={`icon-${item.github ? "shown" : "hidden"}`}
                  >
                    <FontAwesomeIcon icon={faGithub} />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="alumni" name="alumni">
        <h1>
          Our <span>Alumni</span>
        </h1>

        <div className="timeline">
          <Horizontaltimeline
            index={val.value}
            styles={{ outline: "#fa8a13" }}
            linePadding={linePadding}
            indexClick={(index) => {
              // Use the hardcoded currentYear for consistent behavior
              setYear(currentYear - index);
              setVal({ value: index, previous: val.value });
            }}
            getLabel={(date) => {
              return date.slice(0, 4);
            }}
            values={VALUES}
            
          />
        </div>

        <div className="timeline-mobile">
          <div className={`${year < currentYear ? "active" : "disabled"}`}>
            <FontAwesomeIcon
              icon={faAngleLeft}
              onClick={() => {
                if (year < currentYear) setYear(year + 1);
              }}
            />
          </div>
          {year}
          <div className={`${year > beginYear ? "active" : "disabled"}`}>
            <FontAwesomeIcon
              icon={faAngleRight}
              onClick={() => {
                if (year > beginYear) setYear(year - 1);
              }}
            />
          </div>
        </div>

        <div className="alum-wrapper">
          <div className="alum-table">
            {alums.map((data, idx) => {
              // Use detected image extension and absolute path from public/
              let imgLink = `url("/member_images/${data.id}${data.imageExt || '.jpg'}")`;
              let cls = year;
              if (data.year === year) {
                return (
                  <div className="content" key={idx} id={cls}>
                    <div className="alumni-member">
                      <div
                        className={`profile-image-${cls}`}
                        style={{ backgroundImage: imgLink }}
                      ></div>
                      <div className="alumni-name">{data.name}</div>
                      <div className="alumni-designation">
                        {data.designation}
                      </div>
                      <div className="social-link">
                        <a
                          href={data.facebook}
                          target="_blank"
                          rel="noreferrer"
                          id="link"
                          className={`icon-${
                            data.facebook ? "shown" : "hidden"
                          }`}
                        >
                          <FontAwesomeIcon icon={faFacebookF} />
                        </a>

                        <a
                          href={data.mail}
                          target="_blank"
                          rel="noreferrer"
                          className={`icon-${data.mail ? "shown" : "hidden"}`}
                        >
                          <FontAwesomeIcon icon={faEnvelope} />
                        </a>
                        <a
                          href={data.linkedin}
                          target="_blank"
                          rel="noreferrer"
                          className={`icon-${
                            data.linkedin ? "shown" : "hidden"
                          }`}
                        >
                          <FontAwesomeIcon icon={faLinkedinIn} />
                        </a>
                        <a
                          href={data.github}
                          target="_blank"
                          rel="noreferrer"
                          className={`icon-${data.github ? "shown" : "hidden"}`}
                        >
                          <FontAwesomeIcon icon={faGithub} />
                        </a>
                      </div>
                    </div>
                  </div>
                );
              } else return "";
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
